import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import InstarVisionCard01 from 'components/Software/macOS/InstarVision/Users/instarVisionCard01';
import UserTable from 'components/Software/macOS/InstarVision/Users/userTable';
import NavButtons from 'components/Software/macOS/InstarVision/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "InstarVision v3 für macOS",
  "path": "/Software/macOS/InstarVision/Users/",
  "dateChanged": "2018-01-25",
  "author": "Mike Polinowski",
  "excerpt": "InstarVision bietet Ihnen eine hochgradig anpassbare Multi-Level-Benutzerverwaltung.",
  "image": "../P_SearchThumb_InstarVision_Windows.png",
  "social": "/images/Search/P_SearchThumb_InstarVision_Windows.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-Windows-InstarVision_white.webp",
  "chapter": "Software"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <SEOHelmet title='InstarVision v3 für macOS' dateChanged='2018-01-25' author='Mike Polinowski' tag='INSTAR IP Camera' description='Das InstarVision Surveillance Center ist eine IP-Kamera-Software, die 64 Kameras gleichzeitig unterstützen kann, einschließlich Netzwerkkameras, USB-Kameras mit Fernzugriff und Sekundärinstallationen der Software.' image='/images/Search/P_SearchThumb_InstarVision_Windows.png' twitter='/images/Search/P_SearchThumb_InstarVision_Windows.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Software/macOS/InstarVision/Users/' locationFR='/fr/Software/macOS/InstarVision/Users/' crumbLabel="Users" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/29114/Banner_en-InstarVision2-0_Users.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "16.521739130434785%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAfklEQVQI143HsQrCMBhF4f9V9Pkc3BS7OzRxirjoILSv4tK1YCvdSxeXphpiKEdqdumFD+4RRg/ORv4F7z5+AnNnjGG7SyA4RJUWPbk79COg60jVH1Tl/0orz6EZSfaazXpFWlpELh1ybpHrE8kHJOuRzCL5XAPL443Fqfj1F9g5wN/XEwSoAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/e4706/Banner_en-InstarVision2-0_Users.avif 230w", "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/d1af7/Banner_en-InstarVision2-0_Users.avif 460w", "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/7f308/Banner_en-InstarVision2-0_Users.avif 920w", "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/e1c99/Banner_en-InstarVision2-0_Users.avif 1380w", "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/76ea5/Banner_en-InstarVision2-0_Users.avif 1840w", "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/f696c/Banner_en-InstarVision2-0_Users.avif 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/a0b58/Banner_en-InstarVision2-0_Users.webp 230w", "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/bc10c/Banner_en-InstarVision2-0_Users.webp 460w", "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/966d8/Banner_en-InstarVision2-0_Users.webp 920w", "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/445df/Banner_en-InstarVision2-0_Users.webp 1380w", "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/78de1/Banner_en-InstarVision2-0_Users.webp 1840w", "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/882b9/Banner_en-InstarVision2-0_Users.webp 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/81c8e/Banner_en-InstarVision2-0_Users.png 230w", "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/08a84/Banner_en-InstarVision2-0_Users.png 460w", "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/c0255/Banner_en-InstarVision2-0_Users.png 920w", "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/b1001/Banner_en-InstarVision2-0_Users.png 1380w", "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/161ec/Banner_en-InstarVision2-0_Users.png 1840w", "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/29114/Banner_en-InstarVision2-0_Users.png 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/85aac4d72b7d00c6b58b4cbdefff14ee/c0255/Banner_en-InstarVision2-0_Users.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "benutzer",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#benutzer",
        "aria-label": "benutzer permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Benutzer`}</h2>
    <InstarVisionCard01 mdxType="InstarVisionCard01" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "standardbenutzer",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#standardbenutzer",
        "aria-label": "standardbenutzer permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Standardbenutzer`}</h3>
    <p>{`Wenn Sie die Software zum ersten Mal starten, wird der Standardbenutzer hinzugefügt und Sie sind
mit diesem automatisch angemeldet. Auch der `}<a parentName="p" {...{
        "href": "#aktivieren-sie-den-passwortschutz"
      }}>{`Passwortschutz`}</a>{` ist zunächst deaktiviert, sodass Sie sich nicht bei der Software anmelden müssen um auf die Benutzeroberfläche zuzugreifen.
Der Standardbenutzer hat die Rechte eines Administrators und somit keinerlei Einschränkungen.  Sofern Sie die Anmeldedaten des Standardbenutzers nicht geändert haben lauten diese:`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <UserTable mdxType="UserTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Wir empfehlen Ihnen das Standard-Kennwort zu `}<a parentName="p" {...{
        "href": "#bearbeiten-eines-benutzers"
      }}>{`ändern`}</a>{`, sobald der `}<a parentName="p" {...{
        "href": "#aktivieren-sie-den-passwortschutz"
      }}>{`Passwortschutz`}</a>{` aktiv ist.`}</p>
    <h3 {...{
      "id": "aktivieren-sie-den-passwortschutz",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#aktivieren-sie-den-passwortschutz",
        "aria-label": "aktivieren sie den passwortschutz permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Aktivieren Sie den Passwortschutz`}</h3>
    <p>{`Der Passwortschutz ist standardmäßig deaktiviert. Gehen Sie zum `}<a parentName="p" {...{
        "href": "/de/Software/macOS/InstarVision/System#SoftwareLogin"
      }}>{`System Menü - Software Login`}</a>{`, um die Anmeldung zu aktivieren. Sie müssen die Software nach dem Anpassen / Aktivieren des Administratorkontos neu starten und sich mit Ihren neuen Anmeldeinformationen anmelden. Bitte stellen Sie sicher, dass Sie Ihre Administrator-Anmeldung an einem sicheren Ort aufschreiben. Sie können nicht mehr auf die Software zugreifen, wenn die Anmeldung verloren geht. Wenn Sie sich mit einem Konto mit eingeschränkten Benutzerrechten anmelden, wird bei jedem Versuch, auf einen gesperrten Bereich zuzugreifen, eine Anmeldeaufforderung angezeigt. Geben Sie dann einfach Ihr Administrator-Login ein, um Ihre Benutzerrechte zu erhöhen.`}</p>
    <h3 {...{
      "id": "hinzufügen-eines-benutzers",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#hinzuf%C3%BCgen-eines-benutzers",
        "aria-label": "hinzufügen eines benutzers permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Hinzufügen eines Benutzers`}</h3>
    <p>{`Zum Hinzufügen eines neuen Benutzers klicken Sie in das Eingabefeld `}<strong parentName="p">{`Benutzer`}</strong>{` und ersetzen den angezeigten Namen durch den Benutzernamen des neu hinzuzufügenden Benutzers. Klicken Sie danach ins Eingabefeld `}<strong parentName="p">{`Kennwort`}</strong>{` und ersetzen Sie dieses durch das Kennwort des neuen Benutzers. Zur Sicherheit wird das Kennwort bei der Eingabe bzw. Anzeige mit Sternchen vor neugierigen Blicken geschützt. Als nächsten klicken Sie die `}<strong parentName="p">{`+`}</strong>{`-Schaltfläche um die neue Eingabe in die Liste der Benutzer aufzunehmen. Der neue Benutzer ist nun in der Liste ausgewählt und Sie können dessen  `}<a parentName="p" {...{
        "href": "#benutzerrechte"
      }}>{`Benutzerrechte`}</a>{` setzen. Bitte beachten Sie das zu diesem Zeitpunkt die Daten noch nicht gespeichert sind und Sie sich noch nicht mit dem neuen Benutzer anmelden können. Um dies zu erreichen betätigen Sie die `}<strong parentName="p">{`Sichern`}</strong>{`-Schaltfläche.`}</p>
    <h3 {...{
      "id": "bearbeiten-eines-benutzers",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bearbeiten-eines-benutzers",
        "aria-label": "bearbeiten eines benutzers permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bearbeiten eines Benutzers`}</h3>
    <p>{`Möchten Sie zum Beispiel das Passwort eines bestehenden Benutzers ändern, wählen Sie diesen einfach mit einem Klick in der Liste der Benutzer aus. Dieser wird dann markiert und in den Eingabefeldern `}<strong parentName="p">{`Benutzername`}</strong>{` und `}<strong parentName="p">{`Kennwort`}</strong>{` entsprechend aktualisiert. Das Passwort wird immer mit Sternchen angezeigt. Ersetzen Sie dieses durch das neue Passwort und bestätigen Sie dies mit einem klick auf die `}<strong parentName="p">{`Sichern`}</strong>{`-Schaltfläche. Auf die gleiche Art und Weise können Sie auch den Benutzernamen bearbeiten. Sie können aber auch nach Auswahl des Benutzers sämtliche `}<a parentName="p" {...{
        "href": "#benutzerrechte"
      }}>{`Benutzerrechte`}</a>{` durch die Häkchen neu vergeben. Bitte vergessen Sie nicht die Änderungen am Schluss mit einem Klick auf die `}<strong parentName="p">{`Sichern`}</strong>{`-Schaltfläche zu speichern.`}</p>
    <h3 {...{
      "id": "löschen-eines-benutzers",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#l%C3%B6schen-eines-benutzers",
        "aria-label": "löschen eines benutzers permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Löschen eines Benutzers`}</h3>
    <p>{`Wenn Sie einen Benutzer Löschen möchten, wählen Sie diesen einfach mit einem Klick in der Liste der Benutzer aus. Klicken Sie dann die `}<strong parentName="p">{`Löschen`}</strong>{`-Schaltfläche um den ausgewählten Benutzer aus der Liste zu entfernen. Damit der Benutzer auch für zukünftige Anmeldungen nicht mehr zur Verfügung steht, klicken Sie zusätzlich noch auf die `}<strong parentName="p">{`Sichern`}</strong>{`-Schaltfläche.`}</p>
    <h3 {...{
      "id": "benutzerrechte",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#benutzerrechte",
        "aria-label": "benutzerrechte permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Benutzerrechte`}</h3>
    <p>{`Durch Hinzufügen bzw. Entfernen von Häkchen unter der Benutzerliste wird der Zugriff auf bestimmte Bereiche erweitert bzw. eingeschränkt.
Auf der linken Seite werden alle verfügbaren Kanäle aufgelistet. Sobald Sie den Haken eines dieser Kanäle entfernen, ist es dem ausgewählten Benutzer nicht mehr möglich den Videostream dieses Kanals zu betrachten. Auf der rechten Seite befinden sich die Benutzerrechte um Einstellungsmöglichkeiten zu erweitern bzw. zu verbergen. Es gibt folgende Benutzerrechte:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Administrator`}</strong>{`: Ist dieser Haken gesetzt, hat der ausgewählte Benutzer keinerlei  Einschränkungen. Er kann die Ansichten und Funktionen der Software im vollen Umfang nutzen, auch dann wenn weitere Benutzerrechte abgehakt sind. Bitte stellen Sie deshalb sicher, dass bei neuhinzugefügten Benutzern welche eingeschränkte Benutzerrechte haben, dieser Haken immer entfernt ist. Zusätzlich sorgt dieses Recht dafür, dass im Reiter `}<strong parentName="li">{`Benutzer`}</strong>{` die Benutzerliste und deren Rechte angezeigt und bearbeitet werden können. Ein Benutzer ohne dieses Recht kann dort ansonsten nur das persönliche Passwort ändern.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kameraliste`}</strong>{`: Ist dieser Haken gesetzt, ist der Reiter `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/Camera_List"
        }}>{`Kamera Liste`}</a>{` zu sehen. Entfernen Sie den Haken, wenn Sie nicht möchten, dass der ausgewählte Benutzer neue Kameras Hinzufügen, Bearbeiten und Löschen kann.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kamera PTZ`}</strong>{`: Ist dieser Haken gesetzt, ist der Reiter `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/PTZ"
        }}>{`Kamera PTZ`}</a>{` zu sehen. Entfernen Sie den Haken, wenn Sie nicht möchten, dass der ausgewählte Benutzer steuerbare Kameras Positionieren, Schwenken und Zoomen kann.`}</li>
      <li parentName="ul"><strong parentName="li">{`Bildeinstellungen`}</strong>{`: Ist dieser Haken gesetzt, ist der Reiter `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/Image_Adjust"
        }}>{`Bildeinstellungen`}</a>{` zu sehen. Entfernen Sie den Haken, wenn Sie nicht möchten, dass der ausgewählte Benutzer Bildeinstellungen, wie Helligkeit, Kontrast und Sättigung der Kameras abändern kann.`}</li>
      <li parentName="ul"><strong parentName="li">{`Webserver`}</strong>{`: Ist dieser Haken gesetzt, ist der Reiter `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/Webserver"
        }}>{`Webserver`}</a>{` zu sehen. Entfernen Sie den Haken, wenn Sie nicht möchten, dass der ausgewählte Benutzer die Einstellungen des InstarVision eigenen Webservers, wie zum Beispiel die lokale Web-Adresse, abändern kann.`}</li>
      <li parentName="ul"><strong parentName="li">{`Aufnahme`}</strong>{`: Ist dieser Haken gesetzt, ist der Reiter `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/Record"
        }}>{`Aufnahme`}</a>{` zu sehen. Entfernen Sie den Haken, wenn Sie nicht möchten, dass der ausgewählte Benutzer Dauer- oder Alarmaufnahmen oder eine Fotoserie anfertigen bzw. deren Einstellungen bearbeiten kann.`}</li>
      <li parentName="ul"><strong parentName="li">{`System`}</strong>{`: Ist dieser Haken gesetzt, ist der Reiter `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/System"
        }}>{`System`}</a>{` zu sehen. Entfernen Sie den Haken, wenn Sie nicht möchten, dass der ausgewählte Benutzer die Sprache oder das Layout welches beim Start der InstarVision angezeigt wird umstellen kann.`}</li>
      <li parentName="ul"><strong parentName="li">{`Log Info`}</strong>{`: Ist dieser Haken gesetzt, ist im Menü des Reiters `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/Advanced"
        }}>{`Erweitert`}</a>{` die Schaltfläche `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/Advanced/Log"
        }}>{`Log Info`}</a>{` verfügbar. Entfernen Sie den Haken, wenn Sie nicht möchten, dass der ausgewählte Benutzer Log-Informationen der InstarVision einsehen kann.`}</li>
      <li parentName="ul"><strong parentName="li">{`Fernzugriff`}</strong>{`: Ist dieser Haken gesetzt, können Remote-Videostreams empfangen werden. Entfernen Sie den Haken wenn Sie nicht möchten, dass der ausgewählte Benutzer ohne Anmeldeaufforderung auf einen Videostream des InstarVision eigenen Webservers zugreifen kann oder den RTSP-Stream eines Kanals abgreifen kann (siehe `}<a parentName="li" {...{
          "href": "/de/Software/macOS/InstarVision/System/#RTSPServerPort"
        }}>{`System Menü - RTSP Server Port`}</a>{`).`}</li>
    </ul>
    <h3 {...{
      "id": "fernzugriff",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#fernzugriff",
        "aria-label": "fernzugriff permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Fernzugriff`}</h3>
    <p>{`Durch Hinzufügen oder Entfernen von Häkchen unterhalb der Benutzerliste wird der Zugriff auf diese Kameras oder Menüs der Benutzeroberfläche für den ausgewählten Benutzer hinzugefügt oder entfernt. Das Kontrollkästchen Remote legt fest, ob ein Benutzer auf den `}<a parentName="p" {...{
        "href": "/de/Software/macOS/InstarVision/Webserver/"
      }}>{`Webserver`}</a>{` der Software zugreifen und die Live-RTSP-Streams (siehe `}<a parentName="p" {...{
        "href": "/de/Software/macOS/InstarVision/System/"
      }}>{`RTSP Server Port`}</a>{`) von Ihren Kameras empfangen darf. Falls kein Benutzer in der Software angelegt ist, können Sie trotzdem auf den Webserver zugreifen - beachten Sie aber bitte, dass bestimmte Plugins (Quicktime) eine Anmeldung erfordern, um Videos streamen zu können.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      